import { trackEvent } from 'dibs-tracking';

export const trackSortOrderTest = (sortOrderTestValue: string, pageType: string = ''): void => {
    const isAllowedPageType =
        pageType &&
        !['search', 'buy', 'sale', 'seller', 'more-from-seller', 'dealers', 'collection'].includes(
            pageType
        );

    let testValue = null;
    if (sortOrderTestValue === 'RECOMMENDED_SORT_ORDER_VARIANT') {
        testValue = 'variant';
    } else if (sortOrderTestValue === 'RECOMMENDED_SORT_ORDER_CONTROL') {
        testValue = 'control';
    }

    if (!isAllowedPageType || !testValue) {
        return;
    }

    trackEvent({
        category: 'feature ramping',
        action: 'results_page_view',
        label: testValue,
        additional: {
            cdnTestConfigType: 'standard',
            cdnFeatureRamp2: `RECOMMENDED_SORT_ORDER - ${testValue.toUpperCase()}`,
        },
    });
};
